import { useRef } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-2">
              Browse by <span className="text-primary-500">Category</span>
            </h2>
            <p className="text-foreground-500 text-sm">
              Explore our organized pandabuy spreadsheet categories
            </p>
          </div>

          <div className="hidden sm:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 rounded-full bg-background-50 border border-background-300 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-foreground-600"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 rounded-full bg-background-50 border border-background-300 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-foreground-600"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto scrollbar-hide pb-2 -mx-2 px-2"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {categories.map((cat, idx) => (
            <a
              key={cat.slug}
              href={cat.link}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[260px] bg-background-50 rounded-2xl overflow-hidden group cursor-pointer transition-all duration-300 hover:-translate-y-1"
              data-product-shop
            >
              <div className="w-full h-[200px] overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={`${cat.name} - pandabuy spreadsheet category`}
                  title={`${cat.name} Pandabuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={idx < 6 ? 'eager' : 'lazy'}
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-semibold text-foreground-950 text-base">
                    {cat.name}
                  </h3>
                  <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-500 transition-colors text-lg"></i>
                </div>
                <p className="text-foreground-500 text-xs">{cat.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}